import { ActionReducerMap } from '@ngrx/store';

import { configureCleanReducer, configureSyncReducer, TileAction, TileId } from '@contact/upgrade';

/**
 * Name store feature
 */
export const featureName = 'hypervision';

/**
 * Hypervision state interface
 */
export interface HypervisionState {}

/**
 * Initial Hypervision state
 */
export const initialState: HypervisionState = {};

/**
 * Hypervision reducers map
 */
export const reducers: ActionReducerMap<HypervisionState> = {};

const cleanReducer = configureCleanReducer(featureName, {
  initialState,
  keys: [],
  cleanPredicate: action => action.type === TileAction.Reset.type && action.tileId === TileId.HYPERVISOR,
});
const syncReducer = configureSyncReducer(featureName, []);

/**
 * Core meta reducers array
 */
export const metaReducers = [cleanReducer, syncReducer];
